import { registerEventHandler } from 'reffects';
import { state } from 'reffects-store';
import { http } from 'reffects-batteries';

export default function registerEvents() {
  registerEventHandler(
    'REQUEST_RESET_PASSWORD',
    function requestResetPassword(coeffects, { email }) {
      return {
        ...http.post({
          body: {
            account: email,
          },
          url: '/index.php/cod.retrieve_password',
          config: { contentType: 'application/x-www-form-urlencoded' },
          alwaysEvent: ['RESET_PASSWORD_REQUESTED'],
        }),
      };
    }
  );

  registerEventHandler(
    'RESET_PASSWORD_REQUESTED',
    function resetPasswordRequested() {
      return {
        ...state.set({
          disableForgotPasswordForm: true,
        }),
      };
    }
  );
}
